<template>
  <div>
    <NavBtns></NavBtns>

    <!--特色介紹-->
    <section id="fea">
      <div class="featurebox">
        <div class="featureA1">
          <img
            class="img-fluid"
            src="../assets/images/feature_a01.svg"
            alt="OWLocker智慧型寄物櫃"
          />
          <div class="featureB1">
            <img
              class="img-fluid"
              src="../assets/images/feature_b01.svg"
              alt="OWLocker智慧型寄物櫃"
            />
          </div>
          <div class="featitlebox_b">{{ $t('message.nav_feature') }}</div>
        </div>
        <div class="featureA2">
          <img
            class="img-fluid"
            src="../assets/images/feature_a02.svg"
            alt="OWLocker智慧型寄物櫃"
          />
        </div>
        <div class="featureA4">
          <img
            class="img-fluid"
            src="../assets/images/feature_a04.svg"
            alt="OWLocker智慧型寄物櫃"
          />
        </div>
        <div class="featureA3">
          <img
            class="img-fluid"
            src="../assets/images/feature_a03.svg"
            alt="OWLocker智慧型寄物櫃"
          />
        </div>
        <div class="featureA5">
          <img
            class="img-fluid"
            src="../assets/images/feature_a05.svg"
            alt="OWLocker智慧型寄物櫃"
          />
        </div>
        <div class="featureA6">
          <img
            class="img-fluid"
            src="../assets/images/feature_a06.svg"
            alt="OWLocker智慧型寄物櫃"
          />
        </div>
      </div>
      <div class="featureTitle">
        {{ $t('message.fe_smart_lockers') }}
        <div
          class="featitlebox"
          v-html="$t('message.fe_smart_lockers_desc')"
        ></div>
      </div>
    </section>

    <!--尺寸說明-->
    <section id="fea1">
      <div class="feabpad">
        <div class="BlackPromptbox">{{ $t('message.fe_size_s') }}</div>
        <div class="BlackPromptboxtop"></div>
      </div>
      <div class="featureB2">
        <img
          class="img-fluid"
          src="../assets/images/feature_b02.svg"
          alt="OWLocker智慧型寄物櫃,小型"
        />
      </div>
      <div class="featureB3">
        <img
          class="img-fluid"
          src="../assets/images/feature_b03.svg"
          alt="OWLocker智慧型寄物櫃,行李箱"
        />
      </div>
      <div class="arrow_right">
        <img
          class="img-fluid"
          src="../assets/images/arrow_right.svg"
          alt="OWLocker智慧型寄物櫃"
        />
      </div>
      <div class="featureB4">
        <img
          class="img-fluid"
          src="../assets/images/feature_b04.svg"
          alt="OWLocker智慧型寄物櫃,大型"
        />
      </div>
      <div class="featureB5">
        <img
          class="img-fluid"
          src="../assets/images/feature_b03.svg"
          alt="OWLocker智慧型寄物櫃,行李箱"
        />
      </div>
      <div class="arrow_right2">
        <img
          class="img-fluid"
          src="../assets/images/arrow_right.svg"
          alt="OWLocker智慧型寄物櫃"
        />
      </div>
      <div class="feabpad2">
        <div class="BlackPromptboxdown"></div>
        <div class="BlackPromptbox2">{{ $t('message.fe_size_l') }}</div>
      </div>
    </section>
    <section id="fea5">
      <div class="blackbox">{{ $t('message.fe_mobile_support_line') }}</div>
      <ul>
        <li>Apple Lightning</li>
        <li>Micro-USB</li>
        <li>Type-C</li>
      </ul>
      <div class="featureB6">
        <img
          class="img-fluid"
          src="../assets/images/feature_b06.svg"
          alt="Apple Lightning,Micro-USB,Type-C"
        />
      </div>
      <div class="featureB7">
        <img
          class="img-fluid"
          src="../assets/images/feature_b07.svg"
          alt="手機充電櫃"
        />
      </div>
      <div class="featureB8">
        <img
          class="img-fluid"
          src="../assets/images/feature_b08.svg"
          alt="手機充電櫃"
        />
      </div>
      <div class="feaorangebox wow"></div>
    </section>

    <!--支付方式-->
    <section id="fea6">
      <div class="featureF1">
        <img
          class="img-fluid"
          src="../assets/images/feature_f01.svg"
          alt="OWLocker智慧型寄物櫃"
        />
      </div>
      <div class="featureF2 wow">
        <img class="img-fluid" src="../assets/images/cash_all.svg" alt="現金" />
      </div>
      <div class="featureF3 wow">
        <img class="img-fluid" src="../assets/images/jkopay.svg" alt="街口" />
      </div>
      <div class="featureF4 wow">
        <img
          class="img-fluid"
          src="../assets/images/linepay.svg"
          alt="linepay"
        />
      </div>
      <div class="featureF5 wow">
        <img
          class="img-fluid"
          src="../assets/images/e-payment_02.svg"
          alt="信用卡"
        />
      </div>
      <div class="featureF6 wow">
        <img
          class="img-fluid"
          src="../assets/images/iccard2.svg"
          alt="電子票證"
        />
      </div>
      <div class="feabpad">
        <div class="BlackPromptbox">{{ $t('message.fe_payment_title') }}</div>
        <div class="BlackPromptboxtop"></div>
      </div>
    </section>

    <!--網路空櫃查詢-->
    <section id="fea2">
      <div class="featureC1">
        <img
          class="img-fluid"
          src="../assets/images/feature_c01.svg"
          alt="OWLocker智慧型寄物櫃"
        />
      </div>
      <div class="whitebox wow">
        <div class="text">{{ $t('message.fe_query_title') }}</div>
      </div>
      <div class="featureC2 wow">
        <img
          class="img-fluid"
          src="../assets/images/feature_c02.svg"
          alt="OWLocker智慧型寄物櫃"
        />
      </div>
      <div class="featureC3 wow">
        <img
          class="img-fluid"
          src="../assets/images/feature_c03.svg"
          alt="OWLocker智慧型寄物櫃"
        />
      </div>
      <div class="featureC4 wow">
        <img
          class="img-fluid"
          src="../assets/images/feature_c04.svg"
          alt="OWLocker智慧型寄物櫃"
        />
      </div>
      <div class="featureC5 wow">
        <img
          class="img-fluid"
          src="../assets/images/feature_c05.svg"
          alt="OWLocker智慧型寄物櫃"
        />
      </div>
      <div class="featureC6 wow">
        <img
          class="img-fluid"
          src="../assets/images/feature_c06.svg"
          alt="OWLocker智慧型寄物櫃"
        />
      </div>
      <div class="featureC7 wow">
        <img
          class="img-fluid"
          src="../assets/images/feature_c07.svg"
          alt="OWLocker智慧型寄物櫃"
        />
      </div>
    </section>

    <!--終端設備介紹-->
    <section id="fea3">
      <div class="container">
        <div class="row">
          <div class="featureD1 col-lg-6 col-md-6">
            <img
              class="img-fluid"
              src="../assets/images/feature_d01.svg"
              alt="多語輸入"
            />
            <div class="blackbox">{{ $t('message.fe_interface_title') }}</div>
            <div class="circle circle1 wow">中文</div>
            <div class="circle circle2 wow">日本語</div>
            <div class="circle circle3 wow">EN</div>
            <div class="circle circle4 wow">한국어</div>
          </div>
          <div class="featureD2 col-lg-6 col-md-6">
            <img
              class="img-fluid"
              src="../assets/images/feature_d02.svg"
              alt="找零系統"
            />
            <div class="blackbox">{{ $t('message.fe_change_title') }}</div>
          </div>
          <div class="featureD3 col-lg-6 col-md-6">
            <img
              class="img-fluid"
              src="../assets/images/feature_d03.svg"
              alt="不斷電系統"
            />
            <div class="blackbox">{{ $t('message.fe_ups_title') }}</div>
          </div>
          <div class="featureD4 col-lg-6 col-md-6">
            <img
              class="img-fluid"
              src="../assets/images/feature_d04.svg"
              alt="監視系統"
            />
            <div class="blackbox">{{ $t('message.fe_monitor_title') }}</div>
          </div>
        </div>
      </div>
    </section>

    <!--客服機制介紹-->
    <section id="fea4">
      <div class="feaebox"></div>
      <div class="featurelightning">
        <img
          class="img-fluid"
          src="../assets/images/feature_e03.svg"
          alt="OWLocker智慧型寄物櫃"
        />
      </div>
      <div class="feaePromptbox">
        <div class="BlackPromptbox">{{ $t('message.fe_cs_title1') }}</div>
        <div class="BlackPromptboxtop"></div>
      </div>
      <div class="featureE1">
        <img
          class="img-fluid"
          src="../assets/images/feature_e01.svg"
          alt="線上即時客服系統"
        />
        <div class="circle1 wow"><i class="fas fa-phone"></i></div>
        <div class="circle2 wow">
          <img
            class="img-fluid"
            src="../assets/images/feature_e04.svg"
            alt="線上即時客服系統"
          />
        </div>
        <div class="circle3 wow"><i class="fas fa-envelope"></i></div>
      </div>
      <div class="featureE2">
        <img
          class="img-fluid"
          src="../assets/images/feature_e02.svg"
          alt="故障系統自動回報"
        />
      </div>
      <div class="feabpad2">
        <div class="BlackPromptboxdown"></div>
        <div class="BlackPromptbox2">{{ $t('message.fe_cs_title2') }}</div>
      </div>
    </section>

    <!--頁尾-->
    <GzFooter></GzFooter>
  </div>
</template>

<script>
// @ is an alias to /src
import NavBtns from '@/components/NavBtns.vue';
import GzFooter from '@/components/GzFooter.vue';
import { WOW } from 'wowjs';

export default {
  name: 'Feature',
  components: {
    NavBtns,
    GzFooter,
  },
  mounted: function () {
    //動畫處理
    new WOW().init();
  },
};
</script>
